import { ContractorVisitStatusBadge } from "@/components/ContractorVisitStatusBadge";
import { formatNumber } from "@/lib/utils/formatters";
import { ReadProjectScheduleContractorVisit } from "@/types/projectSchedule";
import { memo } from "react";
import { useTranslation } from "react-i18next";

interface ProjectSchedulesVisitDetailsProps {
  visit?: ReadProjectScheduleContractorVisit;
}

const NO_BREAK_SPACE = "\u00A0";

const ProjectSchedulesVisitDetailsComponent = ({
  visit,
}: ProjectSchedulesVisitDetailsProps) => {
  const { t } = useTranslation();

  if (!visit) {
    return <div className="text-sm text-muted-foreground">{t("noData")}</div>;
  }

  return (
    <div className="grid grid-cols-2 gap-4 text-sm">
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectRoles.fields.rate_student_net")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.rates?.rate_student_net
            ? formatNumber(visit.rates.rate_student_net)
            : NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectRoles.fields.rate_student_tax")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.rates?.rate_student_tax
            ? formatNumber(visit.rates.rate_student_tax)
            : NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectRoles.fields.rate_kch_net")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.rates?.rate_kch_net
            ? formatNumber(visit.rates.rate_kch_net)
            : NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectRoles.fields.rate_kch_tax")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.rates?.rate_kch_tax
            ? formatNumber(visit.rates.rate_kch_tax)
            : NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectRoles.fields.rate_zus_net")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.rates?.rate_zus_net
            ? formatNumber(visit.rates.rate_zus_net)
            : NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectRoles.fields.rate_zus_tax")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.rates?.rate_zus_tax
            ? formatNumber(visit.rates.rate_zus_tax)
            : NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectRoles.fields.rate_zus_sick_net")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.rates?.rate_zus_sick_net
            ? formatNumber(visit.rates.rate_zus_sick_net)
            : NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectRoles.fields.rate_zus_sick_tax")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.rates?.rate_zus_sick_tax
            ? formatNumber(visit.rates.rate_zus_sick_tax)
            : NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectRoles.fields.rate_gross")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.rates?.rate_gross
            ? formatNumber(visit.rates.rate_gross)
            : NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectRoles.fields.settlement_type")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.rates?.settlement_type
            ? t(`settlementType.${visit.rates.settlement_type}`)
            : NO_BREAK_SPACE}
        </span>
      </div>
      <div className="flex">
        <span className="font-medium flex-shrink-0">
          {t("projectSchedules.fields.status")}:
        </span>
        <span className="ml-2 flex-1 min-w-[3rem]">
          {visit.status ? (
            <ContractorVisitStatusBadge status={visit.status} />
          ) : (
            NO_BREAK_SPACE
          )}
        </span>
      </div>
    </div>
  );
};

export const ProjectSchedulesVisitDetails = memo(
  ProjectSchedulesVisitDetailsComponent,
);
